module.exports = "//static.hsappstatic.net/ContentComponents/static-2.67510/img/website-page-zero.svg"